export default {"src":"/_next/static/image/public/images/ic_close_image.b3ca4e0ed81bf1449b90d3c8229fed51.svg","height":16,"width":16};